var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeaderOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 30",
    fill: "#ffffff",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 2.13256C0 0.954777 0.891126 0 1.99039 0H18.0096C19.1089 0 20 0.954777 20 2.13256C20 3.31033 19.1089 4.26511 18.0096 4.26511H1.99039C0.891128 4.26511 0 3.31033 0 2.13256Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 14.9995C0 13.8217 0.891126 12.8669 1.99039 12.8669H38.0096C39.1089 12.8669 40 13.8217 40 14.9995C40 16.1773 39.1089 17.132 38.0096 17.132H1.99039C0.891128 17.132 0 16.1773 0 14.9995Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.99039 25.7349C0.891126 25.7349 0 26.6897 0 27.8674C0 29.0452 0.891128 30 1.99039 30H26.0096C27.1089 30 28 29.0452 28 27.8674C28 26.6897 27.1089 25.7349 26.0096 25.7349H1.99039Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderOpen);
export default __webpack_public_path__ + "static/media/headerOpen.56fbdc01.svg";
export { ForwardRef as ReactComponent };